<style lang="scss">
.request-contacts-page {
  .contact-row-wrapper {
    max-height: 400px;
    overflow: auto;
  }
}
</style>

<!-- eslint-disable -->
<template>
  <section class="request-contacts-page">
    <section class="request-call-page__title mb-3">
      <h2 class="font-weight-bolder mb-2">Request Call - Select Contact</h2>

      <h4>Please select the contact you wish to request a video call with.</h4>
    </section>

    <section class="mt-2 contact-row-wrapper pr-1" v-if="!loading">
      <div class="contact-row mobile-column mb-2 d-inline-flex align-items-center full-width pb-1"
           v-for="contact in contacts" :key="contact._id">
        <img class="profile-img" :src="placeholder" width="60px" alt="contact image">
        <section class="request-call-page__contact__details ml-1">
          <h3>{{contact.firstname}} {{contact.lastname}}</h3>
        </section>
        <div class="ui-spacer"></div>
        <b-btn @click="setContact(contact)"
               :variant="isContactSelected(contact) ? 'primary' : 'outline-primary'">
          {{isContactSelected(contact) ? 'Selected' : 'Select'}}
        </b-btn>
      </div>
      <p v-if="contacts.length === 0">You currently have no contacts</p>
    </section>

    <section v-else>
      <b-spinner variant="primary" label="Loading"></b-spinner>
    </section>

    <section class="d-flex full-width mt-1">
      <div class="ui-spacer"></div>
      <b-btn :class="{'disabled': !contactSelected}"
             @click="nextStage()" variant="primary">Next</b-btn>
    </section>
  </section>
</template>
<!-- eslint-enable -->

<script>
import { mapState } from 'vuex';

export default {
  components: {},
  props: {},
  data() {
    return {
      // eslint-disable-next-line global-require
      placeholder: require('../../../assets/images/id/placeholder.png'),
      loading: true,
    };
  },
  computed: {
    ...mapState({
      contacts: state => state.requestCall.contacts,
      contactSelected: state => state.requestCall.booking.contact,
      prison: state => state.auth.prison,
    }),
  },
  async mounted() {
    await this.$store.dispatch('requestCall/refreshContacts');
    this.loading = false;
  },
  methods: {
    setContact(contact) {
      this.$store.commit('requestCall/SET_CONTACT', contact);
    },
    isContactSelected(contact) {
      // eslint-disable-next-line no-underscore-dangle
      return (this.contactSelected && this.contactSelected.user_id === contact.user_id);
    },
    nextStage() {
      this.$store.commit('requestCall/SET_STAGE', this.prison.enable_wings ? 2 : 3);
    },
  },
};
</script>
